import { Model } from 'modules/core/lib/mobx-rest'

export interface IAudit {
  id: string
  data: Record<string, unknown>
  type: string
  date: string
  access_id: number | null
  context: string | null
  become_id: number | null
  event_name: string | null
}

class Audit extends Model<IAudit> {
  static urlRoot() {
    return '/audit_log/audits'
  }
}

export default Audit
